import Resource from './Resource';

export default class ClassPagePost extends Resource {
	constructor(options={}) {
		let {
			routeParams = {},
			query = {},
			data = {},
		} = options;

		let forumType = '';
		if( options.type === 'course' ){
			forumType = 'forums';
		}

		if( options.type === 'group' ){
			forumType = 'student-group-forums';
		}

		if( options.type === 'student' ){
			forumType = 'student-forums';
		}

		let route = `class-pages/:courseSectionGuid/${forumType}/:forumId/topics/:topicId/posts`;

		if( routeParams.postId ){
			route = route + '/:postId';
		}

		let config = {
			route: route,
			query: query,
			routeParams: routeParams,
			data: data
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
	}

	post() {
		return this.request('post');
	}

	put() {
		return this.request('put');
	}

	delete() {
		return this.request('delete');
	}
}
